import { createContext } from 'react';

interface FormValidatorContextType {
  enableRequired: boolean;
  errorFields: Record<string, string>;
}

const FormValidatorContext = createContext<FormValidatorContextType>({
  enableRequired: true,
  errorFields: {},
});

export default FormValidatorContext;
